import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    standalone: false,
    selector: 'app-confirm-delete-modal',
    templateUrl: './confirm-delete-modal.component.html',
    styleUrls: ['./confirm-delete-modal.component.scss'],
})
export class ConfirmDeleteModalComponent {
    @Input() icon = 'calendar_x';
    @Input() theme: 'error' | 'primary' = 'error';
    @Input() titleKey = 'lbl_delete_message_title';
    @Input() subtitleKey = 'lbl_delete_message_warning';
    @Input() confirmLabelKey = 'lbl_delete';
    @Input() cancelLabelKey = 'lbl_go_back';
    /** 'mainTheme' = flw-button con color de theme. 'grey' = mismo estilo neutro que el botón de cancelar */
    @Input() confirmButtonStyle: 'mainTheme' | 'grey' = 'mainTheme';
    @Input() subtitleParams: Object = {};

    constructor(private modalController: ModalController) {}

    confirm() {
        this.modalController.dismiss({ confirmed: true });
    }

    dismiss() {
        this.modalController.dismiss({ confirmed: false });
    }
}
